import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exposure-calendar',
  templateUrl: './exposure-calendar.component.html',
  styleUrls: ['./exposure-calendar.component.css']
})
export class ExposureCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/patients/exposure-calendar.component.ts